import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { Crests } from "../../global/Crests";

export const PaymentCrestsSection = () => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <div className="flex flex-col items-center justify-center py-20 space-y-10">
      <Typography
        sx={{
          color: componentColors.surface.onSurface,
        }}
        className="text-[16px] lg:text-[24px] font-medium text-center"
      >
        Access coaches trusted by leading teams, athletes and organisations
      </Typography>

      <Crests />
    </div>
  );
};
